import { render, staticRenderFns } from "./ModificaArea.vue?vue&type=template&id=df04538a&scoped=true&"
import script from "./ModificaArea.vue?vue&type=script&lang=js&"
export * from "./ModificaArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df04538a",
  null
  
)

export default component.exports